import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 30,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    mobile: {
      desktop: {
        fontSize: "26pt",
        lineHeight: "18pt",
      },
      smartphone: {
        fontSize: "18pt",
        lineHeight: "18pt",
      },
    },
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: 30,
  },
  FORM_FIELD: {
    style: {
      padding: 10,
      maxWidth: "100%",
    },
    inputStyle: {
      width: "100%",
      padding: 15,
      border: "1px solid #DDD",
      borderRadius: 4,
    },
    labelStyle: {
      fontFamily: "Roboto",
      fontSize: "10pt",
      textAlign: "left",
      padding: 5,
    },
  },
};
